import clsx from 'clsx';
import { forwardRef } from 'react';

import { accordionLabelCSS } from './Accordion.sty.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { WithChildren } from '../../core/types/with-children.js';
import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../core/utils/can-receive-default-text-format.js';
import { Text } from '../../typography/text/Text.js';


/** @public */
export type AccordionSectionLabelProps = WithChildren &
  StylingProps &
  DataTestId;

/**
 * Accordion Section Label component
 * @public
 */
export const AccordionSectionLabel = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  AccordionSectionLabelProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: AccordionSectionLabelProps = props;
  const childIsText = _canReceiveDefaultTextFormat(children);

  return (
    <div
      data-testid={dataTestId}
      ref={forwardedRef}
      className={clsx(accordionLabelCSS, consumerClassName)}
      style={consumerStyle}
    >
      {childIsText ? (
        <Text textStyle="base-emphasized" as="p">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
});

(
  AccordionSectionLabel as typeof AccordionSectionLabel & {
    displayName: string;
  }
).displayName = 'Accordion.SectionLabel';
